import {fetchJson} from "./request";

const originalButtonText = Symbol("original buton text");
export function calculateResultCount(form, button) {
    const buttons = Array.isArray(button) ? button : button ? [button] : [];

    buttons.forEach(button => {
        if (!(originalButtonText in button)) {
            button[originalButtonText] = button.innerHTML;
        }
        button.disabled = true;
        button.innerHTML = `<i class="fa fa-spinner fa-spin"></i>`;

    });
    fetchJson((form.action + '/').replace(/\/\/$/, '/') + "calculate/", {
      method: "POST",
      body: new FormData(form)
    })
        .then((response) => {
            buttons.forEach(button => {
                button.textContent = response.buttonText,
                button.disabled = (response.count === 0);
            });
        })
        .catch(() => {
            buttons.forEach(button => {
                button.textContent = button[originalButtonText];
                button.disabled = false;
            });
        });
}

export default {
    calculateResultCount
};
